import React from 'react';

function Footer() {
  return (
    <footer style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 16px', gap: '12px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
        <a href="tel:+97677372929" style={{ color: 'inherit', textDecoration: 'none' }}>📞 (+976) 7737 2929</a>
        <a href="mailto:electronics@elec.mn" style={{ color: 'inherit', textDecoration: 'none' }}>✉️ electronics@elec.mn</a>
      </div>
      <p style={{ margin: 0 }}>&copy; {new Date().getFullYear()} Elec.mn All Rights Reserved.</p>
      <a href="/help" style={{ color: 'inherit', textDecoration: 'none' }}>Help</a>
    </footer>
  );
}

export default Footer;
